export default __webpack_public_path__ + "static/media/page-not-found-loop.855e31ad.gif";